/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Setup_Tomorrow_MarginInputs */

const en_setup_tomorrow_margin = /** @type {(inputs: Setup_Tomorrow_MarginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tomorrow margin`)
};

/**
* | output |
* | --- |
* | "Tomorrow margin" |
*
* @param {Setup_Tomorrow_MarginInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const setup_tomorrow_margin = /** @type {((inputs?: Setup_Tomorrow_MarginInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Setup_Tomorrow_MarginInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_setup_tomorrow_margin(inputs)
});